<div class="mt-5 xl:grid xl:grid-cols-2">
  <div class="h-68 w-11/12 sm:w-126 m-4 border-cgrey-80 border rounded-lg">
    <app-pie [chartFor]="'organization'"></app-pie>
  </div>
  <div class="h-68 w-11/12 sm:w-126 m-4 border-cgrey-80 border rounded-lg relative">
    <app-area [chartFor]="'organization'" [chartType]="'carbon'"></app-area>
  </div>
  <div class="h-68 w-11/12 sm:w-126 m-4 border-cgrey-80 border rounded-lg relative" #assets>
    @defer (on viewport(assets)) {
      <app-area [chartFor]="'organization'" [chartType]="'assets'"></app-area>
    }
  </div>
  <div class="h-68 w-11/12 sm:w-126 m-4 border-cgrey-80 border rounded-lg relative" #money>
    @defer (on viewport(money)) {
      <app-area [chartFor]="'organization'" [chartType]="'money'"></app-area>
    }
  </div>
  <div class="h-68 w-11/12 sm:w-126 m-4 border-cgrey-80 border rounded-lg relative" #gains>
    @defer (on viewport(gains)) {
      <app-area [chartFor]="'organization'" [chartType]="'gains'"></app-area>
    }
  </div>
  <div class="h-68 w-11/12 sm:w-126 m-4 border-cgrey-80 border rounded-lg relative" #damage>
    @defer (on viewport(damage)) {
      <app-area [chartFor]="'organization'" [chartType]="'damage'"></app-area>
    }
  </div>
  <div class="h-68 w-11/12 sm:w-126 m-4 border-cgrey-80 border rounded-lg relative" #income>
    @defer (on viewport(income)) {
      <app-area [chartFor]="'organization'" [chartType]="'income'"></app-area>
    }
  </div>
  <div class="h-68 w-11/12 sm:w-126 m-4 border-cgrey-80 border rounded-lg relative" #quality>
    @defer (on viewport(quality)) {
      <app-area [chartFor]="'organization'" [chartType]="'quality'"></app-area>
    }
  </div>
</div>
